/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_WarningInputs */

const en_mobile_warning = /** @type {(inputs: Mobile_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warning`)
};

const es_mobile_warning = /** @type {(inputs: Mobile_WarningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Advertencia`)
};

/**
* | output |
* | --- |
* | "Warning" |
*
* @param {Mobile_WarningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_warning = /** @type {((inputs?: Mobile_WarningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_WarningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_warning(inputs)
	return en_mobile_warning(inputs)
});